module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lyra/lyr_oc-78881779ef91419ed18cc459dc108fa0.gif";